import AssetCalendar from './partials/AssetCalendar.vue';
import FilePreview from '@jgile/laravel-vue/resources/js/components/FilePreview';
import Projection from './partials/Projection';
import TargetSelector from '../../../advertisers/artwork/TargetSelector.vue';
import Vue from 'vue';
import { scrollToFirstError } from '@jgile/laravel-vue/resources/js/util';

Vue.component('update-asset', {
    components: {
        Projection,
        FilePreview,
        AssetCalendar,
        TargetSelector,
    },
    props: ['attributes', 'leadTimes'],
    data() {
        return {
            asset: new SparkForm({
                id: null,
                name: '',
                description: '',
                restock_modifier_type: 0,
                category_id: null,
                lead_time_id: null,
                asset_type: 'simple',
                status: 0,
                asset_images: [],
                unit_increments: null,
                base_units_available: null,
                base_units_posted: null,
                restock: false,
                restock_threshold: null,
                restock_units_add: null,
                restock_reprice: false,
                restock_modifier_flat: null,
                restock_modifier_percent: null,
                rate_card: null,
                online_price: null,
                bundle_only: false,
                artwork_text: null,
                purchase_total_max_units: null,
                purchase_max_units: null,
                purchase_min_games: null,
                purchase_min_spend: null,
                purchase_min_units: null,
                purchase_min_weeks: null,
                demographics_metrics: null,
                artwork: [],
                creative_specs: {},
            }),
            leadTime: null,
        };
    },

    created() {
        const self = this;
        $(document).scroll(function () {
            self.checkOffset();
        });

        this.asset = _.merge(this.asset, this.attributes);
    },
    computed: {
        previewMedia() {
            return _.get(this.asset, 'asset_images.0');
        },
        canAddPrices() {
            return (
                (this.asset.base_units_available && this.asset.base_units_posted && this.asset.online_price) ||
                (this.asset.base_units_available && this.asset.bundle_only && this.asset.online_price)
            );
        },
    },
    methods: {
        checkOffset() {
            if ($(this.$refs.stickyFooter).offset().top - $('footer.footer').offset().top <= $('footer.footer').outerHeight()) {
                $(this.$refs.stickyFooter).css('position', 'absolute');
            }
            if ($(document).scrollTop() + window.innerHeight < $('footer.footer').offset().top) {
                $(this.$refs.stickyFooter).css('position', 'fixed');
            }
        },
        mediaModal(media) {
            Bus.$emit('openMediaModal', {
                media: media,
                size: 'xl',
            });
        },
        setProjection(newVal, key) {
            if (!_.has(this.asset, `asset_images[${key}].custom_properties.projection`)) {
                _.set(this.asset, `asset_images.${key}.custom_properties`, {});
                _.set(this.asset, `asset_images.${key}.custom_properties.projection`, {});
            }

            _.set(this.asset, `asset_images.${key}.custom_properties.projection`, newVal);
        },
        setTargets(newVal, key) {
            if (!_.has(this.asset, `asset_images[${key}].custom_properties`)) {
                _.set(this.asset, `asset_images.${key}.custom_properties`, {});
            }

            _.set(this.asset, `asset_images.${key}.custom_properties.targets`, newVal);
        },
        getTargets(key) {
            return _.get(this.asset, `asset_images.${key}.custom_properties.targets`, []);
        },
        setAnnotatedImage(dataUrl, key) {
            if (!_.has(this.asset, `asset_images[${key}].custom_properties`)) {
                _.set(this.asset, `asset_images.${key}.custom_properties`, {});
            }

            _.set(this.asset, `asset_images.${key}.custom_properties.annotated_image`, dataUrl);
        },
        getAnnotatedImage(key) {
            return _.get(this.asset, `asset_images.${key}.custom_properties.annotated_image`, null);
        },
        saveAsset() {
            const self = this;
            this.$messenger.loading();

            //
            // Unset restock values if restock is turned off
            //
            if (!this.asset.restock) {
                this.asset.restock_threshold = null;
                this.asset.restock_units_add = null;
                this.asset.restock_reprice = 0;
                this.asset.restock_modifier_percent = null;
                this.asset.restock_modifier_flat = null;
            }

            Spark.put('/api/team/assets/' + this.asset.id, this.asset)
                .then((response) => {
                    Vue.set(this.asset, 'artwork', response.data.artwork);
                    Vue.set(this.asset, 'asset_images', response.data.asset_images);
                    Vue.set(this.asset, 'creative_specs', response.data.creative_specs);

                    if (self.asset.status === 1) {
                        swal({
                            title: 'Completed',
                            type: 'success',
                            showCancelButton: true,
                            confirmButtonText: 'Preview & Post',
                            cancelButtonText: 'Go back to Inventory Manager',
                            confirmButtonClass: 'btn btn-danger mr-2',
                            cancelButtonClass: 'btn btn-cancel',
                            buttonsStyling: false,
                            html: '<strong>This asset is not yet posted!</strong><br>Go to "Preview and Post" to finish posting this asset.',
                        }).then((response) => {
                            if (response.dismiss === 'cancel') {
                                window.location = '/team/inventory';
                            } else {
                                window.location = '/team/inventory/preview';
                            }
                        });
                    } else {
                        self.$noty.success('Asset saved');
                    }
                })
                .catch(() => {
                    scrollToFirstError();
                })
                .finally(() => {
                    this.$messenger.loaded();
                });
        },
        saveAndPrepare() {
            this.asset.status = 1;
            this.saveAsset();
        },
        save() {
            this.asset.status = 0;
            this.saveAsset();
        },
        unpostAsset() {
            const self = this;

            swal({
                title: 'Are you sure?',
                type: 'warning',
                confirmButtonClass: 'btn btn-danger mr-2',
                cancelButtonClass: 'btn btn-cancel',
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.value) {
                    self.asset.status = 0;
                    Spark.put('/api/team/assets/' + this.asset.id, this.asset).then(() => {
                        self.$noty.success('Asset unposted and saved');
                    });
                }
            });
        },
    },
    watch: {
        'asset.lead_time_id': {
            immediate: true,
            handler(newVal) {
                Vue.set(
                    this,
                    'leadTime',
                    _.find(this.leadTimes, (lt) => {
                        return _.toInteger(lt.id) === _.toInteger(newVal);
                    }),
                );
            },
        },
        'asset.bundle_only': function (newVal) {
            if (newVal) {
                Vue.set(this.asset, 'restock', false);
            }
        },
    },
});
